/**
 * LegacyRedirect — mounts at any `/app/*` route and bounces the browser
 * to the V3 equivalent, preserving `?query#hash` where present.
 *
 * Used to keep every legacy URL alive as a redirect target (bookmarks,
 * emails, external inbound links) without ever rendering the legacy
 * AppShell for an authenticated user.
 */
import { Navigate, useLocation } from "react-router-dom";
import { translateLegacyPath } from "@/lib/legacyRedirect";

export default function LegacyRedirect() {
  const loc = useLocation();
  const dest = translateLegacyPath(loc.pathname + loc.search + loc.hash);
  return <Navigate to={dest} replace />;
}
